function getRandomNumbers (num, randLimit)
{
    if(num > randLimit){
        throw new Error("num value must be less or equal to randLimit");
    }

    var numbers = [];

    for (var i = 0; i < num; i++) {
    
        var unique = false;

        do{

            var rand = Math.floor(Math.random() * randLimit) +1;
            var index = numbers.map(function(x){ return x; }).indexOf(rand);

            if(index == -1){
                numbers.push(rand);
                unique = true;
            }

        }while(unique == false);

    }

    return numbers;
}

export {
    getRandomNumbers,
};